import script from "./BannerHero.vue?vue&type=script&setup=true&lang=js"
export * from "./BannerHero.vue?vue&type=script&setup=true&lang=js"

import "./BannerHero.vue?vue&type=style&index=0&id=024dedab&lang=scss&scoped=true"

import exportComponent from "/builds/strooka-jagaad/strooka-fe/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-024dedab"]])

export default __exports__